import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Conflict and climate change remained the main drivers of hunger in 2019. War and insecurity continued to uproot families and create economic turmoil, while climate change caused more frequent and extreme weather events that displaced communities and destroyed countless harvests.`}</p>
    <p>{`As hunger kept rising in 2019, the outlook for 2020 is even more worrying. WFP has `}<a parentName="p" {...{
        "href": "https://www.wfp.org/news/covid-19-will-double-number-people-facing-food-crises-unless-swift-action-taken"
      }}>{`projected`}</a>{` that the number of people facing acute hunger in 2020 could almost double, reaching 265 million, as a result of the socio-economic impact of the COVID-19 pandemic.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      